"use client";

import {
	Alert01Icon,
	Cancel01Icon,
	Checkmark,
	Information,
	Loading03Icon,
} from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
	return (
		<Sonner
			theme="light"
			className="toaster group"
			icons={{
				success: (
					<HugeiconsIcon
						icon={Checkmark}
						strokeWidth={3}
						className="size-3.5"
					/>
				),
				info: (
					<HugeiconsIcon
						icon={Information}
						strokeWidth={3}
						className="size-3.5"
					/>
				),
				warning: (
					<HugeiconsIcon
						icon={Alert01Icon}
						strokeWidth={3}
						className="size-3.5"
					/>
				),
				error: (
					<HugeiconsIcon
						icon={Cancel01Icon}
						strokeWidth={3}
						className="size-3.5"
					/>
				),
				loading: (
					<HugeiconsIcon
						icon={Loading03Icon}
						strokeWidth={3}
						className="size-3.5 animate-spin text-primary"
					/>
				),
			}}
			toastOptions={{
				classNames: {
					toast: "cn-toast",
					title: "cn-toast-title",
					description: "cn-toast-description",
					actionButton: "cn-toast-action",
					cancelButton: "cn-toast-cancel",
					closeButton: "cn-toast-close",
					success: "cn-toast-success",
					error: "cn-toast-error",
					info: "cn-toast-info",
					warning: "cn-toast-warning",
				},
			}}
			{...props}
		/>
	);
};

export { Toaster };
